<template>
  <div
    class="no-data-background"
    :style="getStyle"
    aria-hidden="true"
    data-testid="no-data-bg-image"
  >
    <BaseText
      class="no-data-text"
      :color="NebraskaColors.textSecondary"
      size="s"
      data-testid="no-data-text"
    >
      {{ noContentText }}
    </BaseText>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import noDataChartImagePath from '@/assets/imgs/portfolio/no-data-chart.png';
import noDataChartDarkImagePath from '@/assets/imgs/portfolio/no-data-chart-dark.png';
import { useDashStore } from '@/modules/common/store/DashModule';
import { NoContentTexts } from './constants';

@Component({
  components: { BaseText }
})
export default class ChartNoData extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isVirtual!: boolean;

  @Prop({ type: String, required: true })
  readonly height!: string;

  @Prop({ type: String, required: false })
  readonly text?: string;

  readonly dashModule = useDashStore();
  readonly NebraskaColors = NebraskaColors;

  private get isDarkMode() {
    return this.dashModule.isDarkMode;
  }

  private get getStyle() {
    return {
      '--height': this.height,
      '--no-content-background': this.backgroundStyle
    };
  }

  private get backgroundStyle() {
    return this.isDarkMode
      ? `url(${noDataChartDarkImagePath})`
      : `url(${noDataChartImagePath})`;
  }

  public get noContentText() {
    if (this.text) return this.text;
    return this.isVirtual
      ? NoContentTexts.noContentDataAtAll
      : NoContentTexts.noContentDataForPeriod;
  }
}
</script>

<style lang="less" scoped>
.no-data-background {
  background: var(--no-content-background) no-repeat;
  background-size: cover;
  background-position: center;
  z-index: -1;
  height: var(--height);
  margin: 0 @size-spacing-x350;
}
.no-data-text {
  display: flex;
  text-align: center;
  height: 100%;
  align-items: center;
  margin: auto;
  width: 55%;
}
</style>
